<template>
  <transition name="v-fade">
    <li class="c-list--ranking__item" :class="{ 'is-mine': isProjectDomain }">
      <a :href="item.url" target="_blank" class="c-list--ranking__link">
        <div
          class="c-list--ranking__rank"
          :class="'c-list--ranking__rank--' + item.rank"
        >
          {{ item.rank }}
        </div>
        <div class="c-list--ranking__content">
          <div class="c-list--ranking__title">
            <EllipsisTip>{{ item.title }}</EllipsisTip>
          </div>
          <div class="c-list--ranking__url c-link--blank">
            <EllipsisTip>{{ item.url }}</EllipsisTip>
          </div>
        </div>
        <p
          v-if="intent"
          class="c-list--ranking__intent"
          :class="'c-list--ranking__intent--' + intent.name"
        >
          {{ intent.label }}
          <Tooltip
            class="c-list--intent-message"
            v-if="showUnknownTooltip"
            size="sm"
          >
            タイトルが日本語・英語・数字以外の特殊文字のみのため、インテントが不明となっています。
          </Tooltip>
        </p>
        <div class="c-list--ranking__volume">
          <EllipsisTip>
            {{ item.inflowNumber | separateNumber | truncateNull }}
          </EllipsisTip>
        </div>
      </a>
    </li>
  </transition>
</template>
<script>
import { INTENT_TYPES } from '@/constants';
import EllipsisTip from '@/components/EllipsisTip';
import Tooltip from '@/components/Tooltip';
export default {
  props: ['item', 'project'],
  components: {
    EllipsisTip,
    Tooltip
  },
  computed: {
    intent() {
      if (this.item.intent && this.item.intent.label) {
        return INTENT_TYPES[this.item.intent.label];
      }
      return null;
    },
    showUnknownTooltip() {
      if (this.item.intent.label === INTENT_TYPES.unknown.name) {
        return true;
      }
      return false;
    },
    isProjectDomain() {
      return this.item.url.indexOf(this.project.siteUrl) === 0 ? true : false;
    }
  }
};
</script>
